import { clickHandler } from '@/scripts/analytics/analytics.methods';

const eventName = 'documentLibrary_tracking';
const actionPropTitle = 'documentLibrary_action';
const labelPropTitle = 'documentLibrary_label';

const elements = [...document.querySelectorAll('.js-document-library-link-ga')];
const forms = [...document.querySelectorAll('.js-document-library-form-ga')];

function bindClickEventListener(el) {
  el.addEventListener('click', (e) => {
    clickHandler(
      {
        event: eventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click',
        label: el.innerText,
      },
      e,
    );
  });
}

function bindFilterEventListener(el) {
  el.addEventListener('submit', (e) => {
    clickHandler(
      {
        event: eventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click' + determineSearchResults(el),
        label: `${determineSelectedFilters(el).trim()}`,
      },
      e,
    );
  });
}

function determineSelectedFilters(el) {
  const fd = new FormData(el);
  const filter = Array.from(fd.entries(), (field) => {
    return { name: field[0], value: field[1] };
  })[0];
  const select = el.querySelector(
    `select[name="${filter.name}"] option[value="${filter.value}"]:not([disabled])`,
  );
  const text = select.innerText;
  return text;
}

function determineSearchResults(el) {
  if (!el.classList.contains('js-document-library-form-ga')) {
    return '';
  } else {
    return ' - Filter';
  }
}

function init() {
  if (!elements.length) {
    return;
  }

  elements.forEach(bindClickEventListener);

  if (!forms.length) {
    return;
  }

  forms.forEach(bindFilterEventListener);
}

export default init;
